import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-skeleton-new-card-horizontal',
  standalone: true,
  imports: [],
  templateUrl: './skeleton-new-card-horizontal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonNewCardHorizontalComponent {
  nItems = Array.from({ length: 5 }, (_, i) => i);
}
